import { useState, useEffect } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';
import TranslationText from '@Components/Utilities/TranslationText';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import SortDropdown from '@Components/Shared/SortDropdown';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';

const ListingControlBar = (props) => {

    const routes = useRecoilValue(atoms.routes);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const windowSize = useWindowSize();

    const vip = sandhills.TradeSites.React.ComponentProps['vip'];
    const IsVIP = vip?.VipPortalUrl;
    
    const watchlistCount = props.WatchlistCount;
    const displayWatchlistCount = watchlistCount > 99 ? '99+' : watchlistCount;
    const compressedMobileBar = windowSize.width < 490;
    const [openBar, setOpenBar] = useState(true);
    const [previousMobileState, setPreviousMobileState] = useState(undefined);

    useEffect(() => {
        if (props.NoListings) {
            const footer = document.getElementsByClassName('site-footer')[0];
            const bottomBar = document.getElementsByClassName('bottom-bar')[0];

            if (footer && bottomBar) {
                const footerRect = footer.getBoundingClientRect();
                if (footerRect.top <= window.innerHeight) {
                    const bottomHeight = window.innerHeight - footerRect.top + 10;
                    bottomBar.style.bottom = `${bottomHeight}px`;
                }
            }
        }
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            const bottomBar = document.getElementsByClassName('bottom-bar')?.[0];
            const footer = document.getElementsByClassName('site-footer')?.[0];
            if (bottomBar && footer) {
                const footerRect = footer.getBoundingClientRect();
                const bottomBarRect = bottomBar.getBoundingClientRect();

                if (footerRect.top <= window.innerHeight) {
                    bottomBar.style.position = 'absolute';
                    bottomBar.style.padding = '10px';
                    bottomBar.style.top = `${footerRect.top + window.scrollY - (openBar ? 88.5 : 55.5)}px`;
                    bottomBar.style.bottom = 'auto';
                } else {
                    bottomBar.style.position = 'fixed';
                    bottomBar.style.padding = '0px';
                    bottomBar.style.top = 'auto';
                    bottomBar.style.bottom = '15px';
                }
            }
        };

        const handleResize = () => {
            if (props.IsHostedSite) {
                let startingOpenBar = openBar;

                if (window.innerWidth > 785) {
                    if (!openBar) {
                        setPreviousMobileState(openBar);
                    }
                    setOpenBar(true);
                    const filter = document.getElementsByClassName('bi-center')?.[0];
                    if (filter) {
                        filter.style.height = '80px';
                    }
                } else {
                    if (previousMobileState !== undefined) {
                        setOpenBar(previousMobileState);
                        const filter = document.getElementsByClassName('bi-center')?.[0];
                        if (filter) {
                            filter.style.height = previousMobileState ? '80px' : '47px';
                        }
                    } else if (!startingOpenBar) {
                        setOpenBar(false);
                        const filter = document.getElementsByClassName('bi-center')?.[0];
                        if (filter) {
                            filter.style.height = '47px';
                        }
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [openBar]);


    const handleCollapse = () => {
        const newOpenBarState = !openBar;
        setOpenBar(newOpenBarState);

        if (window.innerWidth <= 785) {
            setPreviousMobileState(newOpenBarState);
        }

        const filter = document.getElementsByClassName('bi-center')?.[0];
        if (filter) {
            filter.style.height = newOpenBarState ? '80px' : '47px';
        }

        gtmPushEvent(gtmEventType.collapseToggle, 'open', newOpenBarState.toString());
    };


    const desktopScroll = () => {
        if (!windowSize.isNotMobile) {

        }
        else {
            if (props.showFilter || props.IsParts) {
                const filter = document.getElementById('filters');
                filter.scrollIntoView({ behavior: "smooth", block: "start" });
                filter.classList.add('sparkle');

                setTimeout(() => {
                    filter.classList.remove('sparkle');
                }, 1500);
            }
        }
    };


    return (
        (props.showFilter || props.IsParts) ?
            <div className='bottom-bar'>
                {windowSize.isMobile ?
                    <div className={'mobile-listing-control-bar' + ((props.IsHostedSite && props.IsParts) ? ' filter-only' : '')} id='nav-control-bar'>
                        {(IsVIP || props.hla || props.sellUrl || props.IsEF || props.RequestACharter) &&
                            <div className='left-half'>
                                {vip &&
                                    <div className={'bar-item ' + (props.ShowAV ? 'av' : 'vip')} id='bar-item-1'>
                                        <a rel='nofollow' href={vip.VipPortalUrl} target='_blank' aria-label={(openBar ? vip.VipPortalTitle + ' ' + translator.translate('sandhills.tradesites.mvc.values') : vip.VipPortalAltText + ' ' + translator.translate('sandhills.tradesites.mvc.values')) +' ('+ translator.translate('sandhills.opensinanewtab') + ')'}>
                                            {openBar ?
                                                <div>
                                                    <img className={props.ShowAV ? "aircraft-valuation-img" : vip.IsVipPlusButton ? "vip-plus-img" : "vip-img"} src={vip.VipPortalImage} alt='' aria-hidden ='true'/>
                                                    <div>{translator.translate('sandhills.tradesites.mvc.values')}</div>
                                                </div>
                                                :
                                                <div>{translator.translate('sandhills.tradesites.mvc.vipvalues')}
                                                </div>
                                            }
                                        </a>
                                    </div>
                                }
                                {props.RequestACharter && !props.IsWatchList &&
                                    <div className='bar-item' id='bar-item-2'>
                                        <a onClick={props.onRequestAQuoteModalToggle}>
                                            {openBar &&
                                                <i className='fas fa-plane-departure' />
                                            }
                                            <TranslationText tKey='sandhills.getquote' />
                                        </a>
                                    </div>
                                }
                                {(!props.showMyBidsURL && (props.hla || props.sellUrl)) &&
                                    <div className='bar-item' id='bar-item-2'>
                                        {props.hla ?
                                            <a href={props.hlaUrl}>
                                                {openBar &&
                                                    <div className='group'>
                                                        <i className='fas fa-long-arrow-alt-up' />
                                                        <i className='fas fa-long-arrow-alt-down' />
                                                    </div>
                                                }
                                                <span>{translator.translate('sandhills.hilowavg')}</span>
                                            </a>
                                            :
                                            <div className='sell-item'>
                                                {props.sellUrl &&
                                                    <a href={props.sellUrl}>
                                                        {openBar &&
                                                            <i className='fas fa-dollar-sign' />
                                                        }
                                                        <span>{translator.translate('sandhills.tradepubwebsite.mvc.sell')}</span>
                                                    </a>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                {(props.showMyBidsURL) &&
                                    <div className='bar-item' id='bar-item-2'>
                                            <a href={props.showMyBidsURL}>
                                                {openBar &&
                                                    <i className='fa-solid fa-gavel' />
                                                }
                                                <span>{translator.translate('sandhills.tradepubwebsite.mvc.mybids')}</span> 
                                            </a>
                                    </div>
                                }
                                {!IsVIP &&
                                    <div className='bar-item' id='bar-item-3'>
                                        <a href={routes.WatchList}>
                                            {openBar &&
                                                <i className='fas fa-heart' >{watchlistCount > 0 ? <div className={'watchlist-count' + (compressedMobileBar ? ' compressed' : '') + (!vip && !props.hla && !props.sellUrl && !props.RequestACharter ? ' mobile-left-half-alone' : '') + (!vip && !props.hla && !props.RequestACharter && !props.sellUrl && compressedMobileBar ? ' compressed-mobile-left-half-alone' : '')}>{displayWatchlistCount}</div> : <></>}</i>
                                            }
                                            <span>{translator.translate('sandhills.tradesites.mvc.watchlist')}</span>
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                        <div className='bar-item bi-center' id='bar-item-center'>
                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.filter.toggle(); } }} onClick={props.filter.toggle}>
                                {openBar &&
                                    <div className='group'>
                                        <i className='fas fa-filter' />
                                        <i className='fas fa-sort small-sort' />
                                    </div>
                                }
                                <span>{translator.translate('sandhillssystem.filter')}</span>
                            </a>
                        </div>
                        {(IsVIP || props.hla || props.sellUrl || props.IsEF || (props.RequestACharter && !props.IsWatchList)) &&
                            <div className='bar-item' />
                        }
                        <div className='right-half'>
                            {!props.IsHostedSite && !props.IsWatchList && IsVIP &&
                                <div className='bar-item' id='bar-item-3'>
                                    <a href={routes.WatchList}>
                                        {openBar &&
                                            <i className='fas fa-heart' >{watchlistCount > 0 ? <div className={'watchlist-count' + (compressedMobileBar ? ' compressed' : '')}>{displayWatchlistCount}</div> : <></>}</i>
                                        }
                                        <span>{translator.translate('sandhills.tradesites.mvc.watchlist')}</span>
                                    </a>
                                </div>
                            }
                            {props.emailAlerts && (!IsVIP || props.IsWatchList) &&
                                <div className='bar-item' id='bar-item-4'>
                                    <a href={currentSite?.Site?.IsAuctionSite ? routes.NotificationSettings : routes.EmailAlerts}>
                                        {openBar &&
                                            <i className='fas fa-bell' />
                                        }
                                        <span>{translator.translate('sandhills.tradepubwebsite.mvc.alerts')}</span>
                                    </a>
                                </div>
                            }
                            {props.RequestACharter && !props.IsWatchList &&
                                <div className='bar-item' id='bar-item-6'>
                                    <a role='button' tabIndex='0' onClick={props.mapViewToggle}>
                                        {openBar &&
                                            <i className='fas fa-map-location-dot' />
                                        }
                                        <TranslationText tKey='sandhills.mapview' />
                                    </a>
                                </div>
                            }
                            {props.sort?.options?.length > 0 &&
                                <div className='bar-item nav-sort' id='bar-item-4'>
                                    <SortDropdown
                                        toggleMobileSort={props.sort.toggle}
                                        ShowMobileSort={props.sort.render}
                                        SortOptions={props.sort.options}
                                        OnChange={props.sort.change}
                                        SelectedValue={props.sort.value}
                                        openBar={openBar}
                                        isFromNavBar={true}
                                        setShowDistanceModal={props.setShowDistanceModal}
                                    />
                                </div>
                            }
                        </div>
                        {(props.IsHostedSite || (!IsVIP && props.IsWatchList && !props.emailAlerts && !props.IsAV)) &&
                            <div className='filler' />
                        }
                        <div className={'collapse-caret' + (openBar ? ' open' : ' collapsed')}>
                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCollapse(); }}} aria-label={openBar ? translator.translate('Sandhills.CRM.DSCRM.Expand') : translator.translate('Sandhills.Collapse')} onClick={handleCollapse}>
                                <i className={`fas ${openBar ? 'fa-caret-down' : 'fa-caret-up'}`} />
                            </a>
                        </div>
                    </div>
                    :
                    <div className={'listing-control-bar' + ((props.IsHostedSite) ? ' filter-only' : '')} id='nav-control-bar'>
                        {(IsVIP || props.hla || props.sellUrl || props.IsAuctionSite || props.RequestACharter) &&
                            < div className='left-half'>
                                {vip &&
                                    <div className={'bar-item ' + (props.ShowAV ? 'av' : 'vip')} id='bar-item-1'>
                                        <a rel='nofollow' href={vip.VipPortalUrl} target='_blank' aria-label={(openBar ? translator.translate('sandhills.tradesites.mvc.values') : vip.VipPortalAltText + ' ' + translator.translate('sandhills.tradesites.mvc.values')) + ' (' + translator.translate('sandhills.opensinanewtab') + ')'}>
                                            {openBar ?
                                                <div>
                                                    <img className={props.ShowAV ? "aircraft-valuation-img" : vip.IsVipPlusButton ? "vip-plus-img" : "vip-img"} src={vip.VipPortalImage} src={vip.VipPortalImage} alt={vip.VipPortalTitle} />
                                                    <div>{translator.translate('sandhills.tradesites.mvc.values')}</div>
                                                </div>
                                                :
                                                <div>{translator.translate('sandhills.tradesites.mvc.vipvalues')}
                                                </div>
                                            }
                                        </a>
                                    </div>
                                }
                                {(!props.showMyBidsURL && (props.hla || props.sellUrl)) &&
                                    <div className='bar-item' id='bar-item-2'>
                                        {props.hla ?
                                            <a href={props.hlaUrl}>
                                                {openBar &&
                                                    <div className='group'>
                                                        <i className='fas fa-long-arrow-alt-up' />
                                                        <i className='fas fa-long-arrow-alt-down' />
                                                    </div>
                                                }
                                                <span>{translator.translate('sandhills.hilowavg')}</span>
                                            </a>
                                            :
                                            <div className='sell-item'>
                                                {props.sellUrl &&
                                                    <a href={props.sellUrl}>
                                                        {openBar &&
                                                            <i className='fas fa-dollar-sign' />
                                                        }
                                                        <span>{translator.translate('sandhills.tradepubwebsite.mvc.sell')}</span>
                                                    </a>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                {(props.showMyBidsURL) &&
                                    <div className='bar-item' id='bar-item-2'>                                                                                  
                                        <a href={props.showMyBidsURL}>
                                            {openBar &&
                                                <i className='fa-solid fa-gavel' />
                                            }
                                            <span>{translator.translate('sandhills.tradepubwebsite.mvc.mybids')}</span> 
                                        </a>                                                                                  
                                    </div>
                                }
                                {(!IsVIP || (props.IsWatchList && props.IsAuctionSite)) && !props.IsAV &&
                                    <div className='bar-item' id='bar-item-3'>
                                        <a href={routes.WatchList}>
                                            {openBar &&
                                                <i className='fas fa-heart' >{watchlistCount > 0 ? <div className={'watchlist-count' + (!props.emailAlerts ? ' no-email-alerts' : '') + (!vip && !props.hla && !props.sellUrl && !props.showMyBidsURL ? ' left-half-alone' : '')}>{displayWatchlistCount}</div> : <></>}</i>
                                            }
                                            <span>{translator.translate('sandhills.tradesites.mvc.watchlist')}</span>
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                        <div className='bar-item bi-center' id='bar-item-center'>
                            <a role='button' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); desktopScroll(); } }} tabIndex='0' onClick={desktopScroll}>
                                {openBar &&
                                    <div className='group'>
                                        <i className='fas fa-filter' />
                                        <i className='fas fa-sort small-sort' />
                                    </div>
                                }
                                <span>{translator.translate('sandhillssystem.filter')}</span>
                            </a>
                        </div>
                        {(IsVIP || props.hla || props.sellUrl || props.showMyBidsURL) &&
                            <div className='bar-item' />
                        }
                        {!props.IsHostedSite &&
                            <div className='right-half'>
                                {(IsVIP || props.IsRY || props.IsAV) &&
                                    <div className='bar-item' id='bar-item-3'>
                                        <a href={routes.WatchList}>
                                            {openBar &&
                                                <i className='fas fa-heart' >{watchlistCount > 0 ? <div className={'watchlist-count' + (!props.emailAlerts ? ' no-email-alerts' : '')}>{displayWatchlistCount}</div> : <></>}</i>
                                            }
                                            <span>{translator.translate('sandhills.tradesites.mvc.watchlist')}</span>
                                        </a>
                                    </div>
                                }
                                {props.emailAlerts &&
                                    <div className='bar-item' id='bar-item-4'>
                                        <a href={currentSite?.Site?.IsAuctionSite ? routes.NotificationSettings : routes.EmailAlerts}>
                                            {openBar &&
                                                <i className='fas fa-bell' />
                                            }
                                            <span>{translator.translate('sandhills.tradepubwebsite.mvc.alerts')}</span>
                                        </a>
                                    </div>
                                }
                                {props.RequestACharter &&
                                    <div className='bar-item' id='bar-item-5'>
                                        <a onClick={props.onRequestAQuoteModalToggle}>
                                            {openBar &&
                                                <i className='fas fa-plane-departure' />
                                            }
                                            <TranslationText tKey='sandhills.getquote' />
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                        {!props.IsHostedSite &&
                            <div className={'collapse-caret' + (openBar ? ' open' : ' collapsed')}>
                                <span role='button' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCollapse(); } }} tabIndex='0' onClick={handleCollapse} title={openBar ? translator.translate('Sandhills.Collapse') : translator.translate('Sandhills.CRM.DSCRM.Expand')} aria-label={openBar ? translator.translate('Sandhills.Collapse') : translator.translate('Sandhills.CRM.DSCRM.Expand')}>
                                    <i className={`fas ${openBar ? 'fa-caret-down' : 'fa-caret-up'}`} />
                                </span>
                            </div>
                        }
                    </div>
                }
            </div>
            :
            <></>
    );
}
export default ListingControlBar;
global.ListingControlBar = ListingControlBar;